// extracted by mini-css-extract-plugin
export default {"card":"h3-z"};